import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/capacitor';
import * as SentryAngular from '@sentry/angular';

import { AppModule } from './app/app.module';
import { setNativeVersionTags } from './app/sentry/set-native-version-tags';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import './extensions';
import { platformBrowser } from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

if (environment.sentry.enabled) {
  Sentry.init(
    {
      dsn: environment.sentry.dsn,
      environment: environment.sentry.environment,
      release: environment.releaseVersion,
      integrations: [SentryAngular.browserTracingIntegration()],
      tracePropagationTargets: environment.sentry.tracingOrigins,

      // Set tracesSampleRate to 1.0 to capture 100%
      // of transactions for performance monitoring.
      // We recommend adjusting this value in production
      tracesSampleRate: 0.01,
    },
    SentryAngular.init,
  );
  void setNativeVersionTags();
}

defineCustomElements(window);

platformBrowser()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
